import React from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';

import { useStyles } from './styles';

/** Field label matching the form inputs (Open Sans 12 Semibold, optional red asterisk). */
export function FieldLabel({ children, required }: { children: string; required?: boolean }) {
  const styles = useStyles();
  return (
    <Stack direction="row" align="center">
      <Text variant="Font Guardian App/Subtitle/Subtitle 12 Semibold" style={styles.fieldLabel}>
        {children}
      </Text>
      {required ? <Text style={styles.asterisk}> *</Text> : null}
    </Stack>
  );
}

/** Inline validation message shown beneath a field (e.g. the birth-date picker). */
export function FieldError({ children }: { children: string }) {
  const styles = useStyles();
  return (
    <Text variant="Font Guardian App/Subtitle/Subtitle 10 Regular" style={styles.errorText}>
      {children}
    </Text>
  );
}
